<template>
  <transition name="el-fade-in-linear">
    <div v-show="dialogVisible" class="popContainer status-dialog">
      <div class="add" :style="{ width: dialogWidth }">
        <span
          class="close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="form_box status-dialog__body">
          <div class="status-dialog__icon" aria-hidden="true">
            <img :src="iconSrc" alt="" />
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import okIcon from './img/ok.png';
import hintIcon from './img/hint.png';
import errorIcon from './img/error.svg';

const TYPE_ICONS = {
  success: okIcon,
  error: errorIcon,
  warning: hintIcon,
};

export default {
  name: 'StatusDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** success | error | warning */
    type: {
      type: String,
      default: 'success',
      validator(value) {
        return ['success', 'error', 'warning'].includes(value);
      },
    },
    width: {
      type: [String, Number],
      default: 500,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },

    dialogWidth() {
      const width = this.width;
      if (typeof width === 'number') {
        return `${width}px`;
      }
      return width;
    },

    iconSrc() {
      return TYPE_ICONS[this.type] || TYPE_ICONS.success;
    },
  },

  methods: {
    onClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.status-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.status-dialog >>> .add {
  position: absolute !important;
  margin: 0 !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.status-dialog >>> .add .close {
  position: absolute;
  top: -25px;
  right: -18px;
  font-size: 38px;
  cursor: pointer;
}

.status-dialog >>> .add .icon-close_round_fill_bold:before {
  background-color: #fff;
  border-radius: 50%;
}

.status-dialog >>> .form_box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 10px;
}

.status-dialog__body {
  padding: 36px 32px 32px;
  text-align: center;
}

.status-dialog__icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
}

.status-dialog__icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

<style>
.status-dialog__title {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #181e2d;
  line-height: 1.4;
}

.status-dialog__desc {
  margin: 0 0 32px;
  font-size: 16px;
  color: #525252;
  line-height: 1.6;
}

.status-dialog__emphasis {
  margin: 0 2px;
  font-weight: 700;
  color: #e8432a;
}

.status-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.status-dialog__btn {
  min-width: 180px;
  height: 48px;
  padding: 0 32px;
  font-size: 16px !important;
  font-weight: 500;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  outline: none;
}

.status-dialog__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.status-dialog__btn--primary {
  color: #fff;
  background: #5b85ff;
}

.status-dialog__btn--primary:hover:not(:disabled) {
  opacity: 0.92;
}

.status-dialog__btn--purchase {
  color: #5b462c;
  background: #ffebc1;
}

.status-dialog__btn--purchase:hover:not(:disabled) {
  background: #ffbc6d;
}

.status-dialog__tip {
  margin: 10px 0 0;
  font-size: 12px;
  color: #f14545;
  line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// src/components/statusDialog/StatusDialog.vue